import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.challenges": "Challenges",
      "nav.events": "Events",
      "nav.leaderboard": "Leaderboard",
      "nav.chat": "Chat",
      "nav.settings": "Settings",
      
      // Challenge System
      "challenges.title": "Challenges",
      "challenges.viewProgress": "View Progress",
      "challenges.joinChallenge": "Join Challenge",
      "challenges.leaveChallenge": "Leave Challenge",
      "challenges.progress": "Progress",
      "challenges.complete": "{{percent}}% Complete",
      "challenges.deadline": "Deadline",
      "challenges.pointsReward": "Points Reward",
      "challenges.description": "Challenge Description",
      "challenges.yourProgress": "Your Progress",
      "challenges.markComplete": "Mark Challenge as Complete",
      "challenges.progressNotes": "Progress Notes (Optional)",
      "challenges.proofRequired": "Proof of Completion (Required for Manual Approval)",
      "challenges.submitReview": "Submit for Completion Review",
      "challenges.acceptedFormats": "Upload documents, screenshots, or other proof of completion. Accepted formats: PDF, JPG, PNG, DOC, DOCX",
      "challenges.progressPlaceholder": "Describe what you accomplished for this challenge...",
      "challenges.submissionSuccess": "Challenge completion submitted for review!",
      
      // Common
      "common.cancel": "Cancel",
      "common.save": "Save",
      "common.submit": "Submit",
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.success": "Success",
      "common.required": "Required",
      "common.optional": "Optional",
      
      // File Upload
      "upload.dragDrop": "Drag and drop files here, or click to select",
      "upload.selectFile": "Select File",
      "upload.uploading": "Uploading...",
      "upload.uploadSuccess": "File uploaded successfully",
      "upload.uploadError": "Failed to upload file",
      "upload.fileSize": "File size must be less than {{size}}MB",
      "upload.fileType": "Accepted file types: {{types}}"
    }
  },
  ru: {
    translation: {
      // Navigation
      "nav.dashboard": "Панель управления",
      "nav.challenges": "Вызовы",
      "nav.events": "События",
      "nav.leaderboard": "Таблица лидеров",
      "nav.chat": "Чат",
      "nav.settings": "Настройки",
      
      // Challenge System
      "challenges.title": "Вызовы",
      "challenges.viewProgress": "Посмотреть прогресс",
      "challenges.joinChallenge": "Присоединиться к вызову",
      "challenges.leaveChallenge": "Покинуть вызов",
      "challenges.progress": "Прогресс",
      "challenges.complete": "{{percent}}% Завершено",
      "challenges.deadline": "Срок",
      "challenges.pointsReward": "Награда в баллах",
      "challenges.description": "Описание вызова",
      "challenges.yourProgress": "Ваш прогресс",
      "challenges.markComplete": "Отметить вызов как завершенный",
      "challenges.progressNotes": "Заметки о прогрессе (Необязательно)",
      "challenges.proofRequired": "Доказательство завершения (Обязательно для ручного одобрения)",
      "challenges.submitReview": "Отправить на проверку завершения",
      "challenges.acceptedFormats": "Загрузите документы, скриншоты или другие доказательства завершения. Принимаемые форматы: PDF, JPG, PNG, DOC, DOCX",
      "challenges.progressPlaceholder": "Опишите, что вы выполнили для этого вызова...",
      "challenges.submissionSuccess": "Завершение вызова отправлено на рассмотрение!",
      
      // Common
      "common.cancel": "Отмена",
      "common.save": "Сохранить",
      "common.submit": "Отправить",
      "common.loading": "Загрузка...",
      "common.error": "Ошибка",
      "common.success": "Успех",
      "common.required": "Обязательно",
      "common.optional": "Необязательно",
      
      // File Upload
      "upload.dragDrop": "Перетащите файлы сюда или нажмите для выбора",
      "upload.selectFile": "Выбрать файл",
      "upload.uploading": "Загрузка...",
      "upload.uploadSuccess": "Файл успешно загружен",
      "upload.uploadError": "Не удалось загрузить файл",
      "upload.fileSize": "Размер файла должен быть менее {{size}}МБ",
      "upload.fileType": "Принимаемые типы файлов: {{types}}"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }
  });

export default i18n;